const deviceSetting = [
  {
    group_name: "Battery Setting",
    groupData: [
      {
        temp_read_only: 3,
        fun_name: "Battery Capacity(0-2000Ah)",
        fun_code: "Batt_Capacity",
        unit: "",
        value: "0",
        type: "value",
        attached: ["LB", "BV", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Max A Charge(0~185A)",
        fun_code: "Max_A_Charge",
        unit: "",
        value: "0",
        type: "value",
        attached: ["LB", "BV", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Max A Discharge(0~185A)",
        fun_code: "Max_A_discharge",
        unit: "",
        value: "0",
        type: "value",
        attached: ["LB", "BV", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Charging Voltage V",
        fun_code: "Charging_voltage",
        unit: "",
        value: "0",
        type: "value",
        attached: ["LB", "BV", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Discharge Voltage V",
        fun_code: "Discharge_voltage",
        unit: "",
        value: "0",
        type: "value",
        attached: ["LB", "BV", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Batt Empty V",
        fun_code: "Empty_V",
        unit: "",
        value: "0",
        type: "value",
        attached: ["LB", "BV", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Batt Resistance(0~200mΩ)",
        fun_code: "battery_resistance_value",
        unit: "",
        value: "0",
        type: "value",
        attached: ["LB", "BV", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Batt charging efficiency(0~100%)",
        fun_code: "Battery_charging_efficiency",
        unit: "",
        value: "0",
        type: "value",
        attached: ["LB", "BV", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Batt Shutdown %(0~100%)",
        fun_code: "battery_capacity_ShutDown",
        unit: "",
        value: "0",
        type: "value",
        attached: ["LB", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Batt Low %(0~100%)",
        fun_code: "battery_capacityLowBatt",
        unit: "",
        value: "0",
        type: "value",
        attached: ["LB", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Batt Restart(0~100%)",
        fun_code: "battery_capacityRestart",
        unit: "",
        value: "0",
        type: "value",
        attached: ["LB", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Batt Shutdown V(38.00~61.00V)",
        fun_code: "battery_voltageShutDow",
        unit: "",
        value: "0",
        type: "value",
        attached: ["BV"],
      },
      {
        temp_read_only: 3,
        fun_name: "Batt Low V(38.00~61.00V)",
        fun_code: "battery_voltageLowBatt",
        unit: "",
        value: "0",
        type: "value",
        attached: ["BV"],
      },
      {
        temp_read_only: 3,
        fun_name: "Batt Restart(38.00~61.00V)",
        fun_code: "battery_voltageRestart",
        unit: "",
        value: "0",
        type: "value",
        attached: ["BV"],
      },
      {
        temp_read_only: 3,
        fun_name: "Activate Battery",
        fun_code: "Lithium_battery_wake_up_sign_bit",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "0", name: "Enabled" },
          { value: "1", name: "Disable" },
        ],
        attached: ["LB", "BV", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Float V(38-61V)",
        fun_code: "Float_V",
        unit: "",
        value: "0",
        type: "value",
        attached: ["BV", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "BMS Lithium Batt Mode(0-20)",
        fun_code: "Lithium_battery_type",
        unit: "",
        value: "0",
        type: "value",
        attached: ["LB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Grid Charge",
        fun_code: "Grid_is_charged_to_enable",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "1", name: "Enabled" },
          { value: "0", name: "Disable" },
        ],
        attached: ["LB", "BV", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Grid Start %(10-90%)",
        fun_code: "Grid_charging_start_capacity_point",
        unit: "",
        value: "0",
        type: "value",
        attached: ["LB", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Grid Start V(38.00~61.00V)",
        fun_code: "Grid_charging_Start_voltage_point",
        unit: "",
        value: "0",
        type: "value",
        attached: ["BV"],
      },
      {
        temp_read_only: 3,
        fun_name: "Grid Start A(0~275A)",
        fun_code: "Grid_charge_the_battery_current",
        unit: "",
        value: "0",
        type: "value",
        attached: ["LB", "BV", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Gen Charge",
        fun_code: "Generator_is_charged_to_enable",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "1", name: "Enabled" },
          { value: "0", name: "Disable" },
        ],
        attached: ["LB", "BV", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Gen Start %(10-90%)",
        fun_code: "Generator_charging_starting_capacity_point",
        unit: "",
        value: "0",
        type: "value",
        attached: ["LB", "BV", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Gen Start A(0~275A)",
        fun_code: "Generator_charges_the_battery_current",
        unit: "",
        value: "0",
        type: "value",
        attached: ["LB", "BV", "BB"],
      },
      {
        temp_read_only: 3,
        // fun_name: "Grid Signal",
        fun_code: "Gen_Grid_Signal_On",
        unit: "",
        value: "0",
        gridSignal: "0",
        genSignal: "0",
        filter: true,
        type_detail: [
          { value: "0", name: "Enabled" },
          { value: "1", name: "Disable" },
        ],
        attached: ["LB", "BV", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Gen Force",
        fun_code: "Force_on_generator_as_load_function",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "0", name: "Enabled" },
          { value: "1", name: "Disable" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "Equalization Days(0-90)",
        fun_code: "Equalization_day_cycle",
        unit: "",
        value: "0",
        type: "value",
        attached: ["BV", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Equalization Hours(0-10)",
        fun_code: "Equalization_time",
        unit: "",
        value: "0",
        type: "value",
        attached: ["BV", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Absorption V(38-61V)",
        fun_code: "Absorption_V",
        unit: "",
        value: "0",
        type: "value",
        attached: ["BV", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Equalization V(38-61V)",
        fun_code: "Equalization_V",
        unit: "",
        value: "0",
        type: "value",
        attached: ["BV", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "TEMPCO(mV/℃/Cell)",
        fun_code: "TEMPCO",
        unit: "",
        value: "0",
        type: "value",
        attached: ["BV", "BB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Low Power Mode<Low Batt",
        fun_code: "Low_Power_Mode",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "1", name: "Enabled" },
          { value: "0", name: "Disable" },
        ],
        attached: ["LB", "BV", "NB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Low Noise Mode",
        fun_code: "Low_Noise_Mode",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "1", name: "Enabled" },
          { value: "0", name: "Disable" },
        ],
        attached: ["LB", "BV", "NB"],
      },
      {
        temp_read_only: 3,
        fun_name: "Disable Float Charge",
        fun_code: "Disable_Float_Charge",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "1", name: "Enabled" },
          { value: "0", name: "Disable" },
        ],
      },
    ],
  },
  {
    group_name: "System Mode",
    groupData: [
      {
        temp_read_only: 3,
        fun_name: "Work Mode",
        fun_code: "limit_control_function",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "0", name: "sell electricity enabled" },
          { value: "1", name: "built-in enabled" },
          { value: "2", name: "extraposition enabled" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "Solar sell",
        fun_code: "Solar_sell",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "1", name: "solar sell" },
          { value: "0", name: "solar Don't sell" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "Max Solar Power(1000 ~ 12000W)",
        fun_code: "MaxSolar_Power",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Zero export power(0~500W)",
        fun_code: "ZeroExport_power",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Max Sell Power(500 ~ 5500W)",
        fun_code: "Limit_the_maximum_power_output_of_the_grid_connection",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Energy pattern",
        fun_code: "Energy_management_model",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "0", name: "Battery priority mode" },
          { value: "1", name: "Load first mode" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "Time Of Use",
        fun_code: "Time_of_Use_Selling_enabled",
        unit: "",
        value: "0",
        type: "option",
        filter: true,
        type_detail: [
          { value: "1", name: "Enabled" },
          { value: "0", name: "Disable" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "Day",
        fun_array: [
          { fun_code: "Monday", fun_name: "Monday", value: "0" },
          { fun_code: "Tuesday", fun_name: "Tuesday", value: "0" },
          { fun_code: "Wednesday", fun_name: "Wednesday", value: "0" },
          { fun_code: "Thursday", fun_name: "Thursday", value: "0" },
          { fun_code: "Friday", fun_name: "Friday", value: "0" },
          { fun_code: "Saturday", fun_name: "Saturday", value: "0" },
          { fun_code: "Sunday", fun_name: "Sunday", value: "0" },
        ],
        unit: "",
        type: "checkbox",
      },
      {
        temp_read_only: 3,
        fun_name: "Grid Charge",
        fun_array: [
          {
            fun_code: "Time_point_1_charge_enable_Grid",
            fun_name: "Time 1",
            value: "0",
          },
          {
            fun_code: "Time_point_2_charge_enable_Grid",
            fun_name: "Time 2",
            value: "0",
          },
          {
            fun_code: "Time_point_3_charge_enable_Grid",
            fun_name: "Time 3",
            value: "0",
          },
          {
            fun_code: "Time_point_4_charge_enable_Grid",
            fun_name: "Time 4",
            value: "0",
          },
          {
            fun_code: "Time_point_5_charge_enable_Grid",
            fun_name: "Time 5",
            value: "0",
          },
          {
            fun_code: "Time_point_6_charge_enable_Grid",
            fun_name: "Time 6",
            value: "0",
          },
        ],
        unit: "",
        type: "checkbox",
      },
      {
        temp_read_only: 3,
        fun_name: "Gen Charge",
        fun_array: [
          {
            fun_code: "Time_point_1_charge_enable_Gen",
            fun_name: "Time 1",
            value: "0",
          },
          {
            fun_code: "Time_point_2_charge_enable_Gen",
            fun_name: "Time 2",
            value: "0",
          },
          {
            fun_code: "Time_point_3_charge_enable_Gen",
            fun_name: "Time 3",
            value: "0",
          },
          {
            fun_code: "Time_point_4_charge_enable_Gen",
            fun_name: "Time 4",
            value: "0",
          },
          {
            fun_code: "Time_point_5_charge_enable_Gen",
            fun_name: "Time 5",
            value: "0",
          },
          {
            fun_code: "Time_point_6_charge_enable_Gen",
            fun_name: "Time 6",
            value: "0",
          },
        ],
        unit: "",
        type: "checkbox",
      },
      {
        temp_read_only: 3,
        fun_name: "Time 1",
        fun_code: "Sell_mode_time_point_1",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Power1(0~5500W)",
        fun_code: "Sell_mode_time_point_1_power",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Battery V1(0~63V)",
        fun_code: "Sell_mode_time_point_1_voltage",
        unit: "",
        value: "0",
        type: "value",
        battV: true,
      },
      {
        temp_read_only: 3,
        fun_name: "Capacity 1",
        fun_code: "1_capacity",
        unit: "",
        value: "0",
        type: "value",
        battV: false,
      },
      {
        temp_read_only: 3,
        fun_name: "Time 2",
        fun_code: "Sell_mode_time_point_2",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Power2(0~5500W)",
        fun_code: "Sell_mode_time_point_2_power",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Battery V2(0~63V)",
        fun_code: "Sell_mode_time_point_2_voltage",
        unit: "",
        value: "0",
        type: "value",
        battV: true,
      },
      {
        temp_read_only: 3,
        fun_name: "Capacity 2",
        fun_code: "2_capacity",
        unit: "",
        value: "0",
        type: "value",
        battV: false,
      },
      {
        temp_read_only: 3,
        fun_name: "Time 3",
        fun_code: "Sell_mode_time_point_3",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Power3(0~5500W)",
        fun_code: "Sell_mode_time_point_3_power",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Battery V3(0~63V)",
        fun_code: "Sell_mode_time_point_3_voltage",
        unit: "",
        value: "0",
        type: "value",
        battV: true,
      },
      {
        temp_read_only: 3,
        fun_name: "Capacity 3",
        fun_code: "3_capacity",
        unit: "",
        value: "0",
        type: "value",
        battV: false,
      },
      {
        temp_read_only: 3,
        fun_name: "Time 4",
        fun_code: "Sell_mode_time_point_4",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Power4(0~5500W)",
        fun_code: "Sell_mode_time_point_4_power",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Battery V4(0~63V)",
        fun_code: "Sell_mode_time_point_4_voltage",
        unit: "",
        value: "0",
        type: "value",
        battV: true,
      },
      {
        temp_read_only: 3,
        fun_name: "Capacity 4",
        fun_code: "4_capacity",
        unit: "",
        value: "0",
        type: "value",
        battV: false,
      },
      {
        temp_read_only: 3,
        fun_name: "Time 5",
        fun_code: "Sell_mode_time_point_5",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Power5(0~5500W)",
        fun_code: "Sell_mode_time_point_5_power",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Battery V5(0~63V)",
        fun_code: "Sell_mode_time_point_5_voltage",
        unit: "",
        value: "0",
        type: "value",
        battV: true,
      },
      {
        temp_read_only: 3,
        fun_name: "Capacity 5",
        fun_code: "5_capacity",
        unit: "",
        value: "0",
        type: "value",
        battV: false,
      },
      {
        temp_read_only: 3,
        fun_name: "Time 6",
        fun_code: "Sell_mode_time_point_6",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Power6(0~5500W)",
        fun_code: "Sell_mode_time_point_6_power",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Battery V6(0~63V)",
        fun_code: "Sell_mode_time_point_6_voltage",
        unit: "",
        value: "0",
        type: "value",
        battV: true,
      },
      {
        temp_read_only: 3,
        fun_name: "Capacity 6",
        fun_code: "6_capacity",
        unit: "",
        value: "0",
        type: "value",
        battV: false,
      },
    ],
  },
  {
    group_name: "Grid Setting",
    groupData: [
      {
        temp_read_only: 3,
        fun_name: "Grid Mode",
        fun_code: "Grid_Mode",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "0", name: "General standard" },
          { value: "1", name: "UL1741&IEE1547" },
          { value: "2", name: "CPUC RULE21" },
          { value: "3", name: "SRD-UL1741" },
          { value: "4", name: "CEI 0-21" },
          { value: "5", name: "EN50549_CZ" },
          { value: "6", name: "Australia_A" },
          { value: "7", name: "Australia_B" },
          { value: "8", name: "Australia_C" },
          { value: "9", name: "AS4777_NewZealand" },
          { value: "10", name: "VDE4105" },
          { value: "11", name: "OVE_Directive _R25" },
          { value: "12", name: "EN50549_CZ_PPDS_L16A" },
          { value: "13", name: "NRS097" },
          { value: "14", name: "G98%/G99" },
          { value: "15", name: "G98%/G99_NI" },
          { value: "16", name: "ESB Newworks(Ireland)" },
          { value: "17", name: "C10%/11" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "Grid Frequency",
        fun_code: "Grid_frequency",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "0", name: "50HZ" },
          { value: "1", name: "60HZ" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "Grid Type",
        fun_code: "Grid_type",
        unit: "",
        value: "0",
        type: "option",
        filter: true,
        type_detail: [
          { value: "0", name: "Single Phase" },
          { value: "1", name: "120/240V Split Phase" },
          { value: "2", name: "120/208V 3 Phase" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "INV Output voltage(V)",
        fun_code: "Microinverter_export_to_grid_cutoff",
        unit: "",
        value: "0",
        type_value: 0,
        type: "Doption",
        type_detail: [
          [
            { value: "0", name: "230V" },
            { value: "1", name: "220V" },
            { value: "2", name: "240V" },
            { value: "3", name: "200V" },
          ],
          [
            { value: "0", name: "120/240V" },
            { value: "1", name: "100/200V" },
            { value: "2", name: "120/240V" },
            { value: "3", name: "110/220V" },
          ],
          [
            { value: "0", name: "120/208V" },
            { value: "1", name: "127/220V" },
          ],
        ],
      },
      // {
      //   temp_read_only: 3,
      //   fun_name: "Import power limiter(0-32000W)",
      //   unit: "",
      //   value: "0",
      //   type: "value",
      // },
      {
        temp_read_only: 3,
        fun_name: "Export power limiter(0-8000W)",
        fun_code: "Limit_the_maximum_power_output_of_the_grid_connection",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        title: "Normal Connect",
      },
      {
        temp_read_only: 3,
        fun_name: "Normal Ramp rate(1.0-999.0S)",
        fun_code: "Normal_Ramp_rate",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Low frequency(45.00-65.00Hz)",
        fun_code: "Grid_Hz_Low",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "High frequency(45.00-65.00Hz)",
        fun_code: "Grid_Hz_High",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Low voltage(80.0-300.0V)",
        fun_code: "Grid_Vol_Low",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "High voltage(80.0-300.0V)",
        fun_code: "Grid_Vol_High",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        title: "Reconnect After Trip",
      },
      {
        temp_read_only: 3,
        fun_name: "Reconnect Ramp rate(1.0-999.0S)",
        fun_code: "Reconnect_Ramp_rate",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Low frequency(45.00-65.00Hz)",
        fun_code: "Grid_Hz_Low_2",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "High frequency(45.00-65.00Hz)",
        fun_code: "Grid_Hz_High_2",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Low voltage(80.0-300.0V)",
        fun_code: "Grid_V_Low_2",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "High voltage(80.0-300.0V)",
        fun_code: "Grid_V_High_2",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        title: true,
      },
      {
        temp_read_only: 3,
        fun_name: "Reconnection Time(1-600S)",
        fun_code: "Restore_connection_time",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "PF",
        fun_code: "Active_power_reg",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        title: true,
      },
      {
        temp_read_only: 3,
        fun_name: "Over voltage U(80.0-300.0V)",
        fun_code: "Over_voltage_U",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "HV3(80.0-300.0V)",
        fun_code: "Grid_Vol_High",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "HV2(80.0-300.0V)",
        fun_code: "HV2",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "HV2-T(0.00 ~ 60.00S)",
        fun_code: "HV2_T",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "HV1(80.0-300.0V)",
        fun_code: "HV1",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "HV1-T(0.00 ~ 60.00S)",
        fun_code: "HV1_T",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "LV1(80.0-300.0V)",
        fun_code: "LV1",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "LV1-T(0.00 ~ 60.00S)",
        fun_code: "LV1_T",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "LV2(80.0-300.0V)",
        fun_code: "LV2",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "LV2-T(0.00 ~ 60.00S)",
        fun_code: "LV2_T",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "LV3(80.0-300.0V)",
        fun_code: "Grid_Vol_Low",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "HF3(45.00-65.00Hz)",
        fun_code: "Grid_Hz_High",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "HF2(45.00-65.00Hz)",
        fun_code: "HF2",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "HF2-T(0.00 ~ 60.00S)",
        fun_code: "HF2_T",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "HF1(45.00-65.00Hz)",
        fun_code: "HF1",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "HF1-T(0.00 ~ 60.00S)",
        fun_code: "HF1_T",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "LF1(45.00-65.00Hz)",
        fun_code: "LF1",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "LF1-T(0.00 ~ 60.00S)",
        fun_code: "LF1_T",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "LF2(45.00-65.00Hz)",
        fun_code: "LF2",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "LF2-T(0.00 ~ 60.00S)",
        fun_code: "LF2_T",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "LF3(45.00-65.00Hz)",
        fun_code: "Grid_Hz_Low",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        title: true,
      },
      {
        temp_read_only: 3,
        fun_name: "F(W)",
        fun_code: "F_W",
        unit: "",
        value: "0",
        type: "option",
        filter: true,
        type_detail: [
          { value: "0", name: "Enabled" },
          { value: "1", name: "Disable" },
        ],
      },
      {
        title: "Over frequency",
        attached: "FW",
      },
      {
        temp_read_only: 3,
        fun_name: "Drop f(-100-100%PE/Hz)",
        fun_code: "Drop_F_over",
        attached: "FW",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "start freq f(45.00-65.00Hz)",
        fun_code: "Start_freq_F_over",
        attached: "FW",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "stop freq f(45.00-65.00Hz)",
        fun_code: "Stop_freq_F_over",
        attached: "FW",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "start delay f(0.00-60.00S)",
        fun_code: "Start_delay_F_over",
        attached: "FW",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "stop delay f(0.00-60.00S)",
        fun_code: "Stop_delay_F_over",
        attached: "FW",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        title: "Under frequency",
        attached: "FW",
      },
      {
        temp_read_only: 3,
        fun_name: "Drop f(-100-100%PE/Hz)",
        fun_code: "Drop_F_under",
        attached: "FW",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "start freq f(45.00-65.00Hz)",
        fun_code: "Start_freq_F_under",
        attached: "FW",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "stop freq f(45.00-65.00Hz)",
        fun_code: "Stop_freq_F_under",
        attached: "FW",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "start delay f(0.00-60.00S)",
        fun_code: "Start_delay_F_under",
        attached: "FW",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "stop delay f(0.00-60.00S)",
        fun_code: "Stop_delay_F_under",
        attached: "FW",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        title: true,
      },
      {
        temp_read_only: 3,
        fun_name: "V(W)",
        fun_code: "V_W",
        unit: "",
        value: "0",
        type: "option",
        filter: true,
        type_detail: [
          { value: "1", name: "Enabled" },
          { value: "0", name: "Disable" },
        ],
      },
      {
        title: true,
        attached: "VW",
      },
      {
        temp_read_only: 3,
        fun_name: "V1(0.0-150.0%)",
        fun_code: "V1_W",
        attached: "VW",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "P1(0-100%)",
        fun_code: "P1_W",
        attached: "VW",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "V2(0.0-150.0%)",
        fun_code: "V2_W",
        attached: "VW",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "P2(0-100%)",
        fun_code: "P2_W",
        attached: "VW",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "V3(0.0-150.0%)",
        fun_code: "V3_W",
        attached: "VW",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "P3(0-100%)",
        fun_code: "P3_W",
        attached: "VW",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "V4(0.0-150.0%)",
        fun_code: "V4_W",
        attached: "VW",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "P4(0-100%)",
        fun_code: "P4_W",
        attached: "VW",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        title: true,
      },
      {
        temp_read_only: 3,
        fun_name: "V(Q)",
        fun_code: "V_Q",
        unit: "",
        value: "0",
        type: "option",
        filter: true,
        type_detail: [
          { value: "1", name: "Enabled" },
          { value: "0", name: "Disable" },
        ],
      },
      {
        title: true,
        attached: "VQ",
      },
      {
        temp_read_only: 3,
        fun_name: "Lock-in/Pn(0.0-100.0%)",
        fun_code: "Lock_in_pn",
        attached: "VQ",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Lock-out/Pn(0.0-100.0%)",
        fun_code: "Lock_out_pn",
        attached: "VQ",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "V1(0.0-150.0%)",
        fun_code: "V1_Q",
        attached: "VQ",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Q1(-100-100%)",
        fun_code: "Q1_Q",
        attached: "VQ",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "V2(0.0-150.0%)",
        fun_code: "V2_Q",
        attached: "VQ",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Q2(-100-100%)",
        fun_code: "Q2_Q",
        attached: "VQ",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "V3(0.0-150.0%)",
        fun_code: "V3_Q",
        attached: "VQ",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Q3(-100-100%)",
        fun_code: "Q3_Q",
        attached: "VQ",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "V4(0.0-150.0%)",
        fun_code: "V4_Q",
        attached: "VQ",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Q4(-100-100%)",
        fun_code: "Q4_Q",
        attached: "VQ",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        title: true,
      },
      {
        temp_read_only: 3,
        fun_name: "P(Q)",
        fun_code: "P_Q",
        unit: "",
        value: "0",
        type: "option",
        filter: true,
        type_detail: [
          { value: "1", name: "Enabled" },
          { value: "0", name: "Disable" },
        ],
      },
      {
        title: true,
        attached: "PQ",
      },
      {
        temp_read_only: 3,
        fun_name: "P1(-100-100%)",
        fun_code: "P1_P",
        attached: "PQ",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Q1(-100-100%)",
        fun_code: "Q1_P",
        attached: "PQ",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "P2(-100-100%)",
        fun_code: "P2_P",
        attached: "PQ",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Q2(-100-100%)",
        fun_code: "Q2_P",
        attached: "PQ",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "P3(-100-100%)",
        fun_code: "P3_P",
        attached: "PQ",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Q3(-100-100%)",
        fun_code: "Q3_P",
        attached: "PQ",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "P4(-100-100%)",
        fun_code: "P4_P",
        attached: "PQ",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Q4(-100-100%)",
        fun_code: "Q4_P",
        attached: "PQ",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        title: true,
      },
      {
        temp_read_only: 3,
        fun_name: "P(PF)",
        fun_code: "P_PF",
        unit: "",
        value: "0",
        type: "option",
        filter: true,
        type_detail: [
          { value: "1", name: "Enabled" },
          { value: "0", name: "Disable" },
        ],
      },
      {
        title: true,
        attached: "PPF",
      },
      {
        temp_read_only: 3,
        fun_name: "Lock-in/Pn(0.0-100.0%)",
        fun_code: "Lock_in_pn_PF",
        attached: "PPF",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Lock-out/Pn(0.0-100.0%)",
        fun_code: "Lock_out_pn_PF",
        attached: "PPF",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "P1(-100-100%)",
        fun_code: "P1_PF",
        attached: "PPF",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "PF1",
        fun_code: "PF1_PF",
        attached: "PPF",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "P2(-100-100%)",
        fun_code: "P2_PF",
        attached: "PPF",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "PF2",
        fun_code: "PF2_PF",
        attached: "PPF",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "P3(-100-100%)",
        fun_code: "P3_PF",
        attached: "PPF",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "PF3",
        fun_code: "PF3_PF",
        attached: "PPF",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "P4(-100-100%)",
        fun_code: "P4_PF",
        attached: "PPF",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "PF4",
        fun_code: "PF4_PF",
        attached: "PPF",
        unit: "",
        value: "0",
        type: "value",
      },
      // {
      //   title: true,
      // },
      // {
      //   temp_read_only: 3,
      //   fun_name: "L/HVRT",
      //   unit: "",
      //   value: "0",
      //   type: "option",
      //   type_detail: [
      //     { value: "0", name: "Enabled" },
      //     { value: "1", name: "Disable" },
      //   ],
      // },
      // {
      //   temp_read_only: 3,
      //   fun_name: "HV1(0.00-150.00%)",
      //   attached: "LHVRT",
      //   unit: "",
      //   value: "0",
      //   type: "value",
      // },
      // {
      //   temp_read_only: 3,
      //   fun_name: "LV1(0.00-150.00%)",
      //   attached: "LHVRT",
      //   unit: "",
      //   value: "0",
      //   type: "value",
      // },
    ],
  },
  {
    group_name: "SmartLoad",
    groupData: [
      {
        temp_read_only: 3,
        fun_name: "SmartLoad Setup",
        fun_code: "Generator_input_is_enabled_as_the_load_output",
        unit: "",
        value: "0",
        type: "option",
        filter: true,
        type_detail: [
          { value: "0", name: "Disable generator input" },
          { value: "1", name: "Enable generator input as load output" },
          { value: "2", name: "Enable as inverter input" },
        ],
        //   [
        //   { value: "0", name: "Generator Input" },
        //   { value: "1", name: "SmartLoad Output" },
        //   { value: "2", name: "Miclnv Input" },
        // ],
      },
      {
        temp_read_only: 3,
        fun_name: "GEN connect to Grid input",
        fun_code: "Gen_connected_to_grid_input",
        unit: "",
        value: "0",
        type: "option",
        attached: ["GI"],
        type_detail: [
          { value: "1", name: "Enable" },
          { value: "0", name: "Disable" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "Solar Power(0 ~ 7000W)",
        fun_code: "MaxSolar_Power",
        unit: "",
        value: "0",
        type: "value",
        attached: ["SO"],
      },
      {
        temp_read_only: 3,
        fun_name: "On Grid always on",
        fun_code: "Microinverter_export_to_grid_cutoff",
        unit: "",
        value: "0",
        type: "option",
        attached: ["SO"],
        type_detail: [
          { value: "1", name: "Enable" },
          { value: "0", name: "Disable" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "Off grid immediately off",
        fun_code: "Off_grid_immediately_Off",
        unit: "",
        value: "0",
        type: "option",
        attached: ["SO"],
        type_detail: [
          { value: "1", name: "Enable" },
          { value: "0", name: "Disable" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "AC couple on load side",
        fun_code: "Ex_MeterCT_ActoLoad",
        unit: "",
        value: "0",
        type: "option",
        attached: ["GI", "SO"],
        filter: true,
        type_detail: [
          { value: "1", name: "Enable" },
          { value: "0", name: "Enable ActoLoad" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "AC couple on grid side",
        fun_code: "Ex_MeterCT_ActoGrid",
        unit: "",
        value: "0",
        type: "option",
        attached: ["GI", "SO"],
        type_detail: [
          { value: "1", name: "Enable" },
          { value: "0", name: "Enable ActoGrid" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "AC_Couple_Frz_High(50.00-65.00Hz)",
        fun_code: "AC_couple_Frz_High",
        unit: "",
        value: "0",
        type: "value",
        attached: ["MI"],
      },
    ],
  },
  {
    group_name: "Basic Settings",
    groupData: [
      {
        fun_code: "Time_syncs",
        fun_name: "Time Syncs",
        temp_read_only: 3,
        unit: "",
        value: "",
        type: "option",
        type_detail: [
          // { value: "11", name: "Enable" },
          // { value: "10", name: "Disable" },
          { value: "3", name: "Enable" },
          { value: "2", name: "Disable" },
        ],
      },
      {
        fun_code: "Beep",
        fun_name: "Beep",
        temp_read_only: 3,
        unit: "",
        value: "",
        type: "option",
        type_detail: [
          // { value: "11", name: "Enable" },
          // { value: "10", name: "Disable" },
          { value: "3", name: "Enable" },
          { value: "2", name: "Disable" },
        ],
      },
      {
        fun_code: "Auto_dim",
        fun_name: "Auto Dim",
        temp_read_only: 3,
        unit: "",
        value: "",
        type: "option",
        type_detail: [
          // { value: "11", name: "Enable" },
          // { value: "10", name: "Disable" },
          { value: "3", name: "Enable" },
          { value: "2", name: "Disable" },
        ],
      },
      {
        fun_code: "AM_PM",
        fun_name: "24 Hour",
        temp_read_only: 3,
        unit: "",
        value: "",
        type: "option",
        type_detail: [
          // { value: "11", name: "Enable" },
          // { value: "10", name: "Disable" },
          { value: "3", name: "Enable" },
          { value: "2", name: "Disable" },
        ],
      },
      {
        fun_code: "Year",
        fun_name: "Year",
        temp_read_only: 3,
        unit: "",
        value: "",
        type: "value",
        max: 99,
        min: 0,
        offset: 2000,
      },
      {
        fun_code: "Month",
        fun_name: "Month",
        temp_read_only: 3,
        unit: "",
        value: "",
        type: "value",
        max: 12,
        min: 1,
      },
      {
        fun_code: "Day",
        fun_name: "Day",
        temp_read_only: 3,
        unit: "",
        value: "",
        type: "value",
        max: 31,
        min: 1,
      },
      {
        fun_code: "Hour",
        fun_name: "Hour",
        temp_read_only: 3,
        unit: "",
        value: "",
        type: "value",
        max: 24,
        min: 0,
      },
      {
        fun_code: "Minute",
        fun_name: "Minute",
        temp_read_only: 3,
        unit: "",
        value: "",
        type: "value",
        max: 59,
        min: 0,
      },
      {
        fun_code: "Remote_lock",
        fun_name: "Remote Lock",
        temp_read_only: 3,
        unit: "",
        value: "",
        type: "option",
        type_detail: [
          { value: "0", name: "ON" },
          { value: "2", name: "OFF" },
        ],
      },
      {
        fun_code: "Factory_reset_enable",
        fun_name: "Factory Reset",
        temp_read_only: 3,
        unit: "",
        value: "",
        type: "option",
        type_detail: [
          { value: "1", name: "Able" },
          { value: "0", name: "Disable" },
        ],
      },
    ],
  },
  {
    group_name: "Advanced Setting",
    groupData: [
      {
        temp_read_only: 3,
        fun_name: "Gen peak-shaving",
        fun_code: "Microinverter_export_to_grid_cutoff",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "1", name: "Enable" },
          { value: "0", name: "Disable" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "Gen peak-shaving power(500 ~ 30000W)",
        fun_code: "GEN_peak_shaving_Power",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Grid peak-shaving",
        fun_code: "Grid_peak_shaving",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "1", name: "Enable" },
          { value: "0", name: "Disable" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "DRM",
        fun_code: "DRM",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "1", name: "Enable" },
          { value: "0", name: "Disable" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "Backup Delay(0-30000ms)",
        fun_code: "Backup_Delay",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "CT ratio(200-8000)",
        fun_code: "CT_ratio",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Grid peak-shaving power(1000 ~ 30000W)",
        fun_code: "GRID_peak_shaving_Power",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Parallel",
        fun_code: "Parallel",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "1", name: "Enable" },
          { value: "0", name: "Disable" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "Equipment mode",
        fun_code: "Master",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "1", name: "Master" },
          { value: "0", name: "Slave" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "Modbus SN(1-16)",
        fun_code: "Modbus_SN",
        unit: "",
        value: "0",
        type: "value",
      },
      {
        temp_read_only: 3,
        fun_name: "Phase",
        fun_code: "Phase",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "0", name: "A" },
          { value: "1", name: "B" },
          { value: "10", name: "C" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "Auto Detect Home Limit Sensors",
        fun_code: "External_sensors_automatically_detect_direction",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "1", name: "Enable" },
          { value: "0", name: "Disable" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "BMS_Err_Stop",
        fun_code: "Microinverter_export_to_grid_cutoff",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "1", name: "Enable" },
          { value: "0", name: "Disable" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "Ex_Meter For CT",
        fun_code: "Ex_MeterCT",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "1", name: "Enable" },
          { value: "0", name: "Enable Meter1 CT" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "A phase",
        fun_code: "Ex_MeterCT_A",
        unit: "",
        value: "0",
        type: "option",
        attached: "EMFCT",
        type_detail: [
          { value: "1", name: "Enable" },
          { value: "0", name: "Disable" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "B phase",
        fun_code: "Ex_MeterCT_B",
        unit: "",
        value: "0",
        type: "option",
        attached: "EMFCT",
        type_detail: [
          { value: "1", name: "Enable" },
          { value: "0", name: "Disable" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "C phase",
        fun_code: "Ex_MeterCT_C",
        unit: "",
        value: "0",
        type: "option",
        attached: "EMFCT",
        type_detail: [
          { value: "1", name: "Enable" },
          { value: "0", name: "Disable" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "Meter Select",
        fun_code: "Meter_Select",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "1", name: "Eastron 3P" },
          { value: "2", name: "CHINT 3P" },
          { value: "3", name: "Eastron 1P" },
          { value: "4", name: "CHINT 1P" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "Grid side INV Meter2",
        fun_code: "Meter2_CT",
        unit: "",
        value: "0",
        type: "option",
        type_detail: [
          { value: "1", name: "Enable" },
          { value: "0", name: "Disable" },
        ],
      },
      // {
      //   temp_read_only: 3,
      //   fun_name: "MPTT Multi-Point Scanning",
      //   unit: "",
      //   value: "0",
      //   type: "option",
      //   type_detail: [
      //     { value: "1", name: "Enable" },
      //     { value: "0", name: "Disable" },
      //   ],
      // },
      {
        temp_read_only: 3,
        fun_name: "DC 1 for WindTurbine",
        fun_code: "DC_1_for_WindTurbine",
        unit: "",
        value: "0",
        type: "option",
        filter: true,
        type_detail: [
          { value: "1", name: "Enable" },
          { value: "0", name: "Disable" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "DC 2 for WindTurbine",
        fun_code: "DC_2_for_WindTurbine",
        unit: "",
        value: "0",
        type: "option",
        filter: true,
        type_detail: [
          { value: "1", name: "Enable" },
          { value: "0", name: "Disable" },
        ],
      },
      {
        temp_read_only: 3,
        fun_name: "V1 (50.0 - 500.0)",
        fun_code: "V1",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "V2 (50.0 - 500.0)",
        fun_code: "V2",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "V3 (50.0 - 500.0)",
        fun_code: "V3",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "V4 (50.0 - 500.0)",
        fun_code: "V4",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "V5 (50.0 - 500.0)",
        fun_code: "V5",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "V6 (50.0 - 500.0)",
        fun_code: "V6",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "V7 (50.0 - 500.0)",
        fun_code: "V7",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "V8 (50.0 - 500.0)",
        fun_code: "V8",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "V9 (50.0 - 500.0)",
        fun_code: "V9",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "V10 (50.0 - 500.0)",
        fun_code: "V10",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "V11 (50.0 - 500.0)",
        fun_code: "V11",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "V12 (50.0 - 500.0)",
        fun_code: "V12",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "Current 1 (0 - 20.0)",
        fun_code: "Current1",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "Current 2 (0 - 20.0)",
        fun_code: "Current2",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "Current 3 (0 - 20.0)",
        fun_code: "Current3",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "Current 4 (0 - 20.0)",
        fun_code: "Current4",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "Current 5 (0 - 20.0)",
        fun_code: "Current5",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "Current 6 (0 - 20.0)",
        fun_code: "Current6",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "Current 7 (0 - 20.0)",
        fun_code: "Current7",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "Current 8 (0 - 20.0)",
        fun_code: "Current8",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "Current 9 (0 - 20.0)",
        fun_code: "Current9",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "Current 10 (0 - 20.0)",
        fun_code: "Current10",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "Current 11 (0 - 20.0)",
        fun_code: "Current11",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
      {
        temp_read_only: 3,
        fun_name: "Current 12 (0 - 20.0)",
        fun_code: "Current12",
        unit: "",
        value: "0",
        type: "value",
        attached: "DC",
      },
    ],
  },
]

deviceSetting.forEach((setting) => {
  setting.groupData.forEach((data: any) => {
    // data.fun_code = data.fun_name;
    data.read_only = data.temp_read_only
    data.hidden = false
  })
})

export default deviceSetting
